import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from '../assets/logo2.png';

const Navbar = () => {
  const [click, setClick] = useState(false);
  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  return (
    <nav className="bg-black h-16 relative z-50">
      <div className="max-w-7xl mx-auto px-4 h-full">
        <div className="flex items-center justify-between h-full">
          <Link
            to="/"
            className="text-white text-2xl font-bold flex items-center hover:opacity-80 bg-transparent clickable"
            onClick={closeMobileMenu}
          >
            <img src={logo} alt="ConfesZ Logo" className="h-20 clickable" />
          </Link>
          
          <div className="md:hidden">
            <button
              onClick={handleClick}
              className="bg-transparent text-white p-2 rounded-md hover:opacity-80 clickable"
            >
              <i className={click ? 'fas fa-times' : 'fas fa-bars'}></i>
            </button>
          </div>

          <div className={`${
            click ? 'flex' : 'hidden'
          } md:flex absolute md:relative top-16 md:top-0 left-0 w-full md:w-auto
          bg-black md:bg-transparent flex-col md:flex-row items-start md:items-center
          z-50`}
          >
            <Link
              to="/"
              className="clickable bg-transparent text-white hover:text-yellow-400 transition-colors duration-300 px-4 py-2 w-full md:w-auto"
              onClick={closeMobileMenu}
              role="clickable"
            >
              Home
            </Link>
            <Link
              to="/downloads"
              className="clickable bg-transparent text-white hover:text-yellow-400 transition-colors duration-300 px-4 py-2 w-full md:w-auto"
              onClick={closeMobileMenu}
              role="clickable"
            >
              Downloads
            </Link>
            <Link
              to="/about"
              className="clickable bg-transparent text-white hover:text-yellow-400 transition-colors duration-300 px-4 py-2 w-full md:w-auto"
              onClick={closeMobileMenu}
              role="clickable"
            >
              About
            </Link>
            <Link
              to="/contact"
              className="clickable bg-transparent text-white hover:text-yellow-400 transition-colors duration-300 px-4 py-2 w-full md:w-auto"
              onClick={closeMobileMenu}
              role="clickable"
            >
              Contact
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;